class HeroSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.hero-premium__track');
    this.slides = [...el.querySelectorAll('.hero-premium__slide')];
    this.prevBtn = el.querySelector('.hero-premium__arrow--prev');
    this.nextBtn = el.querySelector('.hero-premium__arrow--next');
    this.dots = [...el.querySelectorAll('.hero-premium__dot')];
    this.index = 0;
    this.total = this.slides.length;
    this.autoplaySpeed = parseInt(el.getAttribute('data-autoplay-speed'), 10) || 5000;
    this.pauseOnHover = el.hasAttribute('data-pause-on-hover');
    this.loop = el.hasAttribute('data-loop');
    this.swipe = el.hasAttribute('data-swipe');
    this.autoplayTimer = null;
    this.isPaused = false;

    if (this.total < 2) return;

    this.bind();
    this.startAutoplay();
  }

  bind() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', (e) => { e.preventDefault(); this.prev(); });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', (e) => { e.preventDefault(); this.next(); });
    }
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.getAttribute('data-index'), 10));
      });
    });
    this.el.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
    });
    if (this.swipe) {
      this.bindSwipe();
    }
    if (this.pauseOnHover) {
      this.el.addEventListener('mouseenter', () => { this.isPaused = true; this.stopAutoplay(); });
      this.el.addEventListener('mouseleave', () => { this.isPaused = false; this.startAutoplay(); });
    }
  }

  bindSwipe() {
    let sx = 0;
    let ex = 0;
    this.el.addEventListener('touchstart', (e) => { sx = e.changedTouches[0].screenX; }, { passive: true });
    this.el.addEventListener('touchend', (e) => {
      ex = e.changedTouches[0].screenX;
      const diff = sx - ex;
      if (Math.abs(diff) > 50) {
        if (diff > 0) this.next();
        else this.prev();
      }
    }, { passive: true });
  }

  goTo(i) {
    if (this.loop) {
      if (i < 0) i = this.total - 1;
      else if (i >= this.total) i = 0;
    } else {
      if (i < 0) i = 0;
      else if (i >= this.total) i = this.total - 1;
    }
    if (i === this.index) return;
    this.index = i;
    this.track.style.transform = `translateX(-${(this.index / this.total) * 100}%)`;
    this.updateUI();
  }

  next() { this.goTo(this.index + 1); }
  prev() { this.goTo(this.index - 1); }

  updateUI() {
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('hero-premium__slide--active', i === this.index);
      slide.setAttribute('aria-hidden', i !== this.index);
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('hero-premium__dot--active', i === this.index);
      dot.setAttribute('aria-selected', i === this.index);
      dot.setAttribute('tabindex', i === this.index ? '0' : '-1');
    });
    if (this.prevBtn) {
      this.prevBtn.disabled = !this.loop && this.index === 0;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = !this.loop && this.index === this.total - 1;
    }
  }

  startAutoplay() {
    this.stopAutoplay();
    if (this.autoplaySpeed > 0 && !this.isPaused) {
      this.autoplayTimer = setInterval(() => this.next(), this.autoplaySpeed);
    }
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  destroy() {
    this.stopAutoplay();
  }
}

(function() {
  function initHeroSliders() {
    document.querySelectorAll('[data-hero-slider]').forEach(function(el) {
      if (!el._heroSlider) {
        el._heroSlider = new HeroSlider(el);
      }
    });
  }

  if (document.readyState !== 'loading') {
    initHeroSliders();
  } else {
    document.addEventListener('DOMContentLoaded', initHeroSliders);
  }

  if (window.Shopify && Shopify.designMode) {
    initHeroSliders();
  }
})();
